import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { message, Upload, Modal, Button, Tooltip } from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import ChatMessage from '../ChatMessage';
import { cloudFunctions, db, storage } from '../../../config/Fire';
import cloneDeep from 'lodash.clonedeep';
import LoadingPage from '../LoadingPage';
import * as Constants from '../../../constants';
import './styles.css';

import info_icon from '../../../images/info_icon.svg';
import logo_sade_negro from '../../../images/logo_sade_negro.png';
import gallery_add_black from '../../../images/gallery_add_black.svg';
import file_add_black from '../../../images/file_add_black.svg';
import send_black from '../../../images/send_black.svg';
import gallery_add_grey from '../../../images/gallery_add_grey.svg';
import file_add_grey from '../../../images/file_add_grey.svg';
import send_grey from '../../../images/send_grey.svg';

function compareDateHour( a, b ) {
    const hourA = moment(a.sendedDate, 'HH:mm:ss DD/MM/YYYY');
    const hourB = moment(b.sendedDate, 'HH:mm:ss DD/MM/YYYY');
    if ( hourA.isAfter(hourB) ) {
      return 1;
    }
    if ( hourA.isBefore(hourB) ) {
      return -1;
    }
    return 0;
};

const Chat = props => {

    const[textSender, setTextSender] = useState("")
    const[isLoadingChat, setIsLoadingChat] = useState(false)
    const[fileGallery, setFileGallery] = useState([])
    const[showModalUploadGallery, setShowModalUploadGallery] = useState(false)
    const[file, setFile] = useState([])
    const[showModalUploadFile, setShowModalUploadFile] = useState(false)
    const refBottomChat = useRef(null)
    const[showModalInfoProcedure, setShowModalInfoProcedure] = useState(false)

    const { procedure, user } = props;

    useEffect(() => {
        if(procedure.chat && procedure.chat.messages && refBottomChat) {
            refBottomChat.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [procedure.chat])

    const renderMessages = messages => {
        if(messages) {
            var messagesArray = Object.values(messages);
            messagesArray.sort(compareDateHour);
            return(
                <div className="chaMessageDivContainer">
                    {
                        messagesArray.map(message => <ChatMessage key={`${message.id}`} chatMessage={message} userId={user.id} clientId={procedure.userId}/>)
                    }
                </div>
            )
        }
    }

    const onKeyPressInput = e => {
        if (e.key === 'Enter' && textSender !== "" && !isLoadingChat && props.enableChat) {
            onSubmitMessage()
        }
    }

    const onSubmitMessage = () => {
        setIsLoadingChat(true)
        cloudFunctions.requestNewChatMessage({
            procedureId: procedure.id,
            senderId: user.id,
            senderName: user.name,
            message: textSender,
            employeeCategory: procedure.employeeCategory,
            userId: procedure.userId,
            customID: procedure.customID,
        })
        .then((result) => {
            setIsLoadingChat(false)
            setTextSender("")
        })
        .catch((err) => {
            setIsLoadingChat(false)
            console.log(err)
            message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
        })
    }

    useEffect(() => {
        //setTextSender("")
        if(procedure && procedure.state === Constants.procedureStateType.PENDING && procedure.chat && procedure.chat.messages) {
            onSeenMessages(procedure.chat.messages)
        }
    }, [procedure])

    const onSeenMessages = messages => {
        var messagesToSave = {}
        messagesToSave = cloneDeep(messages)
        var updateMessages = false
        Object.values(messagesToSave).forEach(message => {
            if (!isMyMessage(message.senderId, procedure.userId, user.id)) {
                if (message.wasSeen === false) {
                    message.wasSeen = true
                    updateMessages = true
                }
            }
        });
        if (updateMessages) {
            console.log("update messages")
            db.ref(`${Constants.MAIN_NODES.PROCEDURES}/${procedure.id}/chat/messages`).update(messagesToSave)
        }
    }

    const isMyMessage = (senderId, clientId, myId) => {
        if (myId === senderId) {
            return true
        } else {
            return (senderId !== clientId && myId !== clientId)
        }
    }

    const getProcedureName = category => {
        const categorySplited = category.split("_")
        const textProcedure = `${categorySplited[categorySplited.length - 2]} - ${categorySplited[categorySplited.length - 1]}`
        return textProcedure
    }

    const getProcedureState = state => {
        switch (state) {
            case Constants.procedureStateType.PENDING:
                return "Pendiente"
            case Constants.procedureStateType.FINISHED:
                return "Finalizado"
        }
    }

    const handleCancelSenderModalGallery = () => {
        setShowModalUploadGallery(false)
        setFileGallery([])
    }

    const handleSendSenderModalGallery = () => {
        console.log("send image")
        if(fileGallery.length === 1) {
            setIsLoadingChat(true)
            cloudFunctions.getServerTimestamp()
            .then((timestampResult) => {
                if(timestampResult.data && timestampResult.data.timestamp) {
                    const currentDate = Date(timestampResult.data.timestamp * 1000)
                    const dateString = moment(currentDate).format("YYYY/MM/DD")
                    const sendedDateLong = moment(currentDate).toDate().getTime();
                    const fileTypeSplited = fileGallery[0].type.split("/")
                    if(fileTypeSplited.length === 2) {
                        const imageStoragePath = `chats/images/${dateString}/${procedure.id}-${sendedDateLong}.${fileTypeSplited[1]}`
                        if(fileGallery[0].originFileObj) {
                            return storage.ref().child(imageStoragePath).put(fileGallery[0].originFileObj)
                            .then(() => {
                                cloudFunctions.requestNewChatImage({
                                    procedureId: procedure.id,
                                    senderId: user.id,
                                    senderName: user.name,
                                    message: imageStoragePath,
                                    employeeCategory: procedure.employeeCategory,
                                    userId: procedure.userId,
                                    customID: procedure.customID,
                                })
                                .then((result) => {
                                    if(result.data && result.data.code === 0) {
                                        setIsLoadingChat(false)
                                        setShowModalUploadGallery(false)
                                        setFileGallery([])
                                    } else {
                                        setIsLoadingChat(false)
                                        message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                                    }
                                })
                                .catch((err) => {
                                    setIsLoadingChat(false)
                                    console.log(err)
                                    message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                                })
                            })
                            .catch((err) => {
                                setIsLoadingChat(false)
                                console.log(err)
                                message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                            })
                        } else {
                            setShowModalUploadGallery(false)
                            setFileGallery([])
                            console.log("error image: " + JSON.stringify(fileGallery[0]))
                            setIsLoadingChat(false)
                            message.error("Se produjo un error con la imagen. Por favor, vuelva a intentarlo.")
                        }
                    } else {
                        setShowModalUploadGallery(false)
                        setFileGallery([])
                        console.log("error image: " + fileTypeSplited)
                        setIsLoadingChat(false)
                        message.error("Se produjo un error con la imagen. Por favor, vuelva a intentarlo.")
                    }
                } else {
                    setIsLoadingChat(false)
                    message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                }
            })
            .catch((err) => {
                setIsLoadingChat(false)
                console.log(err)
                message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
            })
        } else {
            setShowModalUploadGallery(false)
            setFileGallery([])
            setIsLoadingChat(false)
            message.error("Se produjo un error con la imagen. Por favor, vuelva a intentarlo.")
        }
    }

    //Images

    const beforeUpload = (file) => {
        return new Promise((resolve, reject) => {
        setTimeout(() => {
            //const isJPG = file.type === 'image/jpeg';
            //const isPNG = file.type === 'image/png';
            if(file.size > (1024*1024*10)) { //size max 10MB
                message.error('El tamaño máximo de la imagen es de 10MB');
                reject(file);
            } else {
                resolve(file);
            }
        }, 0);
        });
    }

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
          onSuccess("ok");
        }, 0);
    };

    const uploadButton = () => (
        <div>
          <PlusOutlined />
          <div className="ant-upload-text">Agregar</div>
        </div>
    );

    const handleChangeImageGallery = ({ fileList }) => setFileGallery(fileList);

    //Files

    const handleCancelSenderModalFile = () => {
        setShowModalUploadFile(false)
        setFile([])
    }

    const handleSendSenderModalFile = () => {
        if(file.length === 1) {
            setIsLoadingChat(true)
            cloudFunctions.getServerTimestamp()
            .then((timestampResult) => {
                if(timestampResult.data && timestampResult.data.timestamp) {
                    const currentDate = Date(timestampResult.data.timestamp * 1000)
                    const currentDateLong = moment(currentDate).toDate().getTime()
                    const dateString = moment(currentDate).format("YYYY/MM/DD")
                    //const fileTypeSplited = file[0].type.split("/")
                    if(file[0].name && file[0].name !== "") {
                        var fileStoragePath = `chats/files/${dateString}/${currentDateLong}/${file[0].name}`
                        if(file[0].originFileObj) {
                            return storage.ref().child(fileStoragePath).put(file[0].originFileObj)
                            .then(() => {
                                cloudFunctions.requestNewChatFile({
                                    procedureId: procedure.id,
                                    senderId: user.id,
                                    senderName: user.name,
                                    message: fileStoragePath,
                                    employeeCategory: procedure.employeeCategory,
                                    userId: procedure.userId,
                                    customID: procedure.customID,
                                })
                                .then((result) => {
                                    if(result.data && result.data.code === 0) {
                                        setIsLoadingChat(false)
                                        setShowModalUploadFile(false)
                                        setFile([])
                                    } else {
                                        setIsLoadingChat(false)
                                        message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                                    }
                                })
                                .catch((err) => {
                                    setIsLoadingChat(false)
                                    console.log(err)
                                    message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                                })
                            })
                            .catch((err) => {
                                setIsLoadingChat(false)
                                console.log(err)
                                message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                            })
                        } else {
                            setShowModalUploadFile(false)
                            setFile([])
                            console.log("error file: " + JSON.stringify(file[0]))
                            setIsLoadingChat(false)
                            message.error("Se produjo un error con el archivo. Por favor, vuelva a intentarlo.")
                        }
                    } else {
                        setShowModalUploadFile(false)
                        setFile([])
                        console.log("error file: " + file[0].name)
                        setIsLoadingChat(false)
                        message.error("El tipo de archivo no es aceptado. Por favor, vuelva a intentarlo.")
                    }
                } else {
                    setIsLoadingChat(false)
                    message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
                }
            })
            .catch((err) => {
                setIsLoadingChat(false)
                console.log(err)
                message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
            })
        } else {
            setShowModalUploadFile(false)
            setFile([])
            setIsLoadingChat(false)
            message.error("Se produjo un error con el archivo. Por favor, vuelva a intentarlo.")
        }
    }

    const handleChangeFile = ({ fileList }) => setFile(fileList);

    const beforeUploadFile = (file) => {
        return new Promise((resolve, reject) => {
        setTimeout(() => {
            if(file.size > (1024*1024*100)) { //size max 100MB
                message.error('El tamaño máximo del archivo es de 100MB');
                reject(file);
            } else {
                resolve(file);
            }
        }, 0);
        });
    }

    const uploadButtonFile = () => (
        <Button>
            <UploadOutlined /> Agregar archivo
        </Button>
    );

    return (
        <Grid className="chatContainer">
            <Row className="chatHeader">
                <Col xs={10} className="chatTitleHeader">
                    <h2>{procedure.userName}</h2>
                </Col>
                <Col xs={2} className="chatInfoHeader" onClick={() => setShowModalInfoProcedure(true)}>
                    <Tooltip placement="bottom" title={"Información del trámite"}>
                        <img src={info_icon} alt="info"/>
                    </Tooltip>
                </Col>
            </Row>
            <Row className="chatBody">
                <img className="chatImageBodyBackground" src={logo_sade_negro} alt="Grupo SADE"/>
                <div className="chatBodyFront">
                    {renderMessages((procedure.chat && procedure.chat.messages) ? procedure.chat.messages : null)}
                    <div style={{ float:"left", clear: "both" }}
                        ref={refBottomChat}>
                    </div>
                </div>
                {
                    isLoadingChat &&
                        <div className="chatBodyLoading">
                            <LoadingPage />
                        </div>
                }
            </Row>
            <Row className="chatSender">
                {
                    (!isLoadingChat && props.enableChat) ?
                        <Col xs={1} className="chatGallerySender">
                            <Tooltip placement="top" title={"Cargar imagen"}>
                                <img src={gallery_add_black} alt="imagen" onClick={() => setShowModalUploadGallery(true)}/>
                            </Tooltip>
                        </Col>
                        :
                        <Col xs={1} className="chatGallerySenderDisabled">
                            <img src={gallery_add_grey} alt="imagen"/>
                        </Col>
                }
                {
                    (!isLoadingChat && props.enableChat) ?
                        <Col xs={1} className="chatFileSender">
                            <Tooltip placement="top" title={"Cargar archivo"}>
                                <img src={file_add_black} alt="archivo" onClick={() => setShowModalUploadFile(true)}/>
                            </Tooltip>
                        </Col>
                        :
                        <Col xs={1} className="chatFileSenderDisabled">
                            <img src={file_add_grey} alt="archivo"/>
                        </Col>
                }
                <Col xs={8} className="chatTextSender">
                    <input onKeyPress={e => onKeyPressInput(e)} disabled={(isLoadingChat || !props.enableChat)} value={textSender} onChange={(event) => setTextSender(event.target.value)} className="chatTextSenderInput" placeholder="Nuevo mensaje..."/>
                </Col>
                    {
                        (textSender !== "" && !isLoadingChat && props.enableChat) ?
                            <Col xs={2} className="chatSendSender">
                                <img src={send_black} alt="enviar" onClick={onSubmitMessage} />
                            </Col>
                            :
                            <Col xs={2} className="chatSendSenderDisabled">
                                <img src={send_grey} alt="enviar"/>
                            </Col>
                    }
            </Row>
            <Modal
            name="gallery"
            visible={showModalUploadGallery}
            title={"Cargar imagen"}
            onCancel={handleCancelSenderModalGallery}
            onOk={handleSendSenderModalGallery}
            footer={[
                <Button key="back" onClick={handleCancelSenderModalGallery}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" loading={isLoadingChat} disabled={(fileGallery.length !== 1 || isLoadingChat)} onClick={handleSendSenderModalGallery}>
                    Enviar
                </Button>,
            ]}
            >
                <Upload
                name="galleryUpload"
                fileList={fileGallery}
                accept="image/*"
                multiple={false}
                listType="picture-card"
                customRequest={dummyRequest}
                beforeUpload={beforeUpload}
                onPreview={null}
                onChange={handleChangeImageGallery}
                >
                    {fileGallery.length >= 1 ? null : uploadButton()}
                </Upload>
            </Modal>
            <Modal
            name="file"
            visible={showModalUploadFile}
            title={"Cargar archivo"}
            onCancel={handleCancelSenderModalFile}
            onOk={handleSendSenderModalFile}
            footer={[
                <Button key="back" onClick={handleCancelSenderModalFile}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" loading={isLoadingChat} disabled={(file.length !== 1 || isLoadingChat)} onClick={handleSendSenderModalFile}>
                    Enviar
                </Button>,
            ]}
            >
                <Upload
                name="fileUpload"
                fileList={file}
                multiple={false}
                customRequest={dummyRequest}
                beforeUpload={beforeUploadFile}
                onPreview={null}
                onChange={handleChangeFile}
                >
                    {file.length >= 1 ? null : uploadButtonFile()}
                </Upload>
            </Modal>
            <Modal
            name="info"
            visible={showModalInfoProcedure}
            title={"Información del trámite"}
            onCancel={() => setShowModalInfoProcedure(false)}
            onOk={() => setShowModalInfoProcedure(false)}
            footer={null}>
                <h2>Trámite: {getProcedureName(procedure.category)}</h2>
                <h2>Descripción: {procedure.description}</h2>
                <h2>Estado: {getProcedureState(procedure.state)}</h2>
                <h2>Iniciado: {procedure.createDate}</h2>
                <h2>Nombre: {procedure.userName}</h2>
                <h2>Teléfono: {procedure.userPhone}</h2>
                <h2>Correo: {procedure.userEmail}</h2>
            </Modal>
        </Grid>
    );
};

Chat.propTypes = {
    procedure: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

export default Chat;
